import { render, staticRenderFns } from "./drug.vue?vue&type=template&id=5d456448&scoped=true"
import script from "./drug.vue?vue&type=script&lang=js"
export * from "./drug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d456448",
  null
  
)

export default component.exports